import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import notificationsActionsCreator from "../../store/notifications/action-creators";
import classNames from 'classnames';

class NotificationsContainer extends Component {


  displayNotificationIcon(notification) {

    switch (notification.type) {
      case 'success' :
        return (
          <i className="fa fa-check"/>
        );
      case 'warning':
        return (
          <i className="fa fa-exclamation "/>
        );
      case 'error':
        return (
          <i className="fa fa-exclamation-triangle "/>
        );
    }

  }

  render() {
    return (
      <div className="notifications-container">
        <Fragment>
          {/*<button className="button primary small"*/}
                  {/*onClick={() => this.props.addNotification()}> Add notification*/}
          {/*</button>*/}
          {
            this.props.notificationsQueue.map((notification, key) => (
              <div className={classNames('single-toaster', {removed: notification.remove})} key={key}>
                <div className={classNames("notification-toaster", "toaster-" + notification.type)}>
                  <div className="notification-container">
                    <div className="icon-type-container">
                      {this.displayNotificationIcon(notification)}
                    </div>
                    <div className="notification-content">
                      {notification.content}
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </Fragment>

      </div>
    )

  }

}


// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    notificationsQueue: state.notifications.queue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNotification: () => {

      let notificationExamples = [
        {
          'type': 'success',
          'content': 'Success',
        },
        {
          'type': 'error',
          'content': 'Error has occurred',
        },
        {
          'type': 'warning',
          'content': 'warning !!!',
        }
      ];

      return dispatch(notificationsActionsCreator.addNotification(notificationExamples[Math.floor(Math.random() * notificationExamples.length)]));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer);